<template>
  <transition-group
    name="fade"
    tag="div"
    class="px-2 flex space-x-2 items-center"
  >
    <button
      v-for="user in collaborators"
      :key="user.id"
      type="button"
      class="size-7"
      @click="onClickCollaborator(user.id)"
    >
      <user-avatar
        :short-name="user.shortName"
        :name="user.fullName"
        :avatar-url="user.avatarUrl"
        :gravatar-url="user.gravatarUrl"
        :color="user.color"
        :is-collaborator="true"
      />
    </button>
  </transition-group>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import emitter from 'tiny-emitter/instance';

import { EVENT } from '@/constants.js';

import UserAvatar from '../../board/UserAvatar.vue';

const store = useStore();

const collaborators = computed(
  () => store.getters['application/channels/getCollaborators']
);

const onClickCollaborator = id => {
  const data = store.getters['application/channels/getCollaborator'](id);
  if (data.cursor) {
    emitter.emit(EVENT.ZOOMTOBOARD, {
      x: data.cursor.x,
      y: data.cursor.y,
      boardId: data.board,
    });
  }
};
</script>
